import { Typography } from '@material-tailwind/react'
import React from 'react'

const ErrorMessage = ({ fieldState }) => {
    return (
        <>
            {fieldState.error ? (
                <Typography
                    variant="small"
                    color="gray"
                    className="flex items-center gap-1 font-normal text-error text-xs">
                    {fieldState.error.message}
                </Typography>
            ) : (<div className='mt-5'></div>)}
        </>
    )
}

export default ErrorMessage